import React from 'react';
import { Box, Heading, Text, List, ListItem, ListIcon, Container, Highlight } from '@chakra-ui/react';
import { MdFiberManualRecord } from 'react-icons/md';

const aboutText = `At Business Automation we believe that the key to our success is our people. We are a team of passionate, innovative, and dedicated professionals who are committed to making a difference. We are constantly pushing the boundaries of what's possible, and we want you to be a part of our journey.`;

const visionText = `To empower organizations for better customer experience using technology, process and people. Its goals also include being the first choice among customers and employees.`;

const makeDifferenceText = `Exlopre our current job openings and apply today. Togather we can achive greate things`;

const whyList = [
  'Business Automation is an advanced growing company with an excellent working environment.',
  'Business Automation is a long experienced company and has been serving in ITES Sector since 1998.',
  'Friendly and sincere behavior with fellow colleagues.',
  'The company has various leave policies for employees of all levels. The policy includes Training Leave, Short Leave, Maternity Leave and Paternity Leave among other leaves.',
  'Business Automation provides opportunities for employees to take professional-oriented courses for skill & career development and also provides full financial assistance for the said training as per training policy.',
  'The working environment for women employees is prestigious and respectful.',
  'We are committed to achieve our goal.'
];

const JoinUsAboutSection = () => (
  <Container maxW="6xl" py={{ base: 8, md: 16 }}>
    <Text fontSize={{ base: 'lg', md: 'xl' }} mb={12} color="gray.800">
      {aboutText}
    </Text>

    <Heading as="h2" fontSize={{ base: '2xl', md: '3xl' }} color="#25575F" mb={3} fontWeight="bold">
      Vision
    </Heading>
    <Text fontSize={{ base: 'lg', md: 'xl' }} mb={12} color="gray.800">
      {visionText}
    </Text>

    <Heading as="h2" fontSize={{ base: '2xl', md: '3xl' }} color="#25575F" mb={5} fontWeight="bold">
      <Highlight query="should" styles={{ color: '#25575F' }}>
        Why should you join us?
      </Highlight>
    </Heading>
    <List spacing={5} fontSize={{ base: 'lg', md: 'xl' }} color="gray.800" mb={12}>
      {whyList.map((item, idx) => (
        <ListItem key={idx} display="flex" alignItems="flex-start">
          <ListIcon as={MdFiberManualRecord} color="#25575F" boxSize={3} mt={1} />
          {item}
        </ListItem>
      ))}
    </List>  

    <Heading as="h2" fontSize={{ base: '2xl', md: '3xl' }} color="#25575F" mb={3} fontWeight="bold">
      Ready to make a difference?
    </Heading>
    <Text fontSize={{ base: 'lg', md: 'xl' }} mb={12} color="gray.800">
      {makeDifferenceText}
    </Text>
  </Container>
);

export default JoinUsAboutSection; 